// frontend/src/components/common/PDFViewer.js
import React, { useState } from "react";
import { FiRotateCcw, FiZoomIn, FiZoomOut, FiDownload } from "react-icons/fi";
import { Document, Page, pdfjs } from "react-pdf";

// Configure workerSrc using react-pdf's pdfjs instance
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PDFViewer = ({ file }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1);
  const [rotation, setRotation] = useState(0);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = file;
    link.download = file.split("/").pop();
    link.click();
  };

  return (
    <div className="flex flex-col items-center w-full h-full">
      <div className="flex gap-2 mb-2 pdf-viewer-controls">
        <button onClick={() => setScale((p) => Math.min(p + 0.2, 3))} className="p-2 bg-gray-200 rounded"><FiZoomIn /></button>
        <button onClick={() => setScale((p) => Math.max(p - 0.2, 0.6))} className="p-2 bg-gray-200 rounded"><FiZoomOut /></button>
        <button onClick={() => setRotation((r) => (r + 90) % 360)} className="p-2 bg-gray-200 rounded"><FiRotateCcw /></button>
        <button onClick={handleDownload} className="p-2 bg-blue-500 text-white rounded"><FiDownload /></button>
      </div>

      <div className="flex-grow overflow-auto border p-2 rounded bg-gray-50 w-full flex justify-center">
        <Document
          file={file}
          onLoadSuccess={({ numPages }) => {
            setNumPages(numPages);
            setPageNumber(1);
          }}
          loading="Loading..."
        >
          <Page
            pageNumber={pageNumber}
            scale={scale}
            rotate={rotation}
            width={Math.min(window.innerWidth * 0.8, 750)}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </Document>
      </div>

      <div className="flex justify-between items-center w-full mt-2 pdf-viewer-controls">
        <button
          onClick={() => setPageNumber((p) => Math.max(p - 1, 1))}
          disabled={pageNumber <= 1}
          className="bg-gray-300 px-3 py-1 rounded disabled:opacity-50"
        >
          ⬅ Prev
        </button>
        <span>Page {pageNumber} of {numPages || "--"}</span>
        <button
          onClick={() => setPageNumber((p) => Math.min(p + 1, numPages))}
          disabled={!numPages || pageNumber >= numPages}
          className="bg-gray-300 px-3 py-1 rounded disabled:opacity-50"
        >
          Next ➡
        </button>
      </div>
    </div>
  );
};

export default PDFViewer;
